export default __webpack_public_path__ + "static/media/origin.1382c8ed.svg";